module.exports = __webpack_public_path__ + "img/img (37).51c48e4a.png";